<!-- On the profile the detail page already draws header and tabs; only "+ Neue Person" needs its own. -->
<ng-container *ngIf="isNew; else formOnly">
    <app-aumico-layout hideFooter="true">
        <ng-container header>
            <ham-page-header [title]="pageHeader.value | i18next" [backButtonRoute]="['../overview']"></ham-page-header>
        </ng-container>
        <ng-container content>
            <ng-container *ngTemplateOutlet="personForm"></ng-container>
        </ng-container>
    </app-aumico-layout>
</ng-container>

<ng-template #formOnly>
    <ng-container *ngTemplateOutlet="personForm"></ng-container>
</ng-template>

<ng-template #personForm>
    <aumico-person-form
        [person]="person"
        [isNew]="isNew"
        [active]="active"
        [users]="users"
        [companies]="companies"
        [tags]="tags"
        [tagUsage]="tagUsage"
        [tagError]="tagError"
        [saving]="saving"
        [cpmmActive]="cpmmActive"
        (save)="onSave($event)"
        (delete)="onDelete()"
        (statusChange)="onStatusChange($event)"
        (tagCreate)="onTagCreate($event)"
        (tagDeleteRequest)="onTagDeleteRequest($event)"
        (tagDeleteConfirm)="onTagDeleteConfirm($event)"
        (tagDeleteCancel)="onTagDeleteCancel()"
        (companyClick)="onCompanyClick($event)"
    ></aumico-person-form>
</ng-template>
